import { render, staticRenderFns } from "./MonitorForm.vue?vue&type=template&id=fb5d08c0&"
import script from "./MonitorForm.vue?vue&type=script&lang=js&"
export * from "./MonitorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports